<div class="header__breadcrumbs">
  <button class="button button--big button--lined button--home" [routeOrUrl]="'/'" title="{{backToHomeText(language$ | async)}}">
    <div class="button--home__logo">
      <img class="menu__eye" src="/assets/svgs/logo.svg" alt=""/><h5>Naturblick</h5>
    </div>
  </button>
  <button *ngIf="relativeCrumb" [routeOrUrl]="relativeCrumb.path" [queryParams]="relativeCrumb.params" class="button button--big button--lined">{{relativeCrumb.name}}</button>
</div>
